import { shared } from "@src/util/shared";

export const useMe = () => {
  const permissions = shared.get("permissions") || [];
  const roles = shared.get("roles") || [];
  const user = shared.get("user") || {};
  const isSuperAdmin = shared.get("isAdmin");
  return { permissions, roles, user, isSuperAdmin };
};
